import Splide from "@splidejs/splide";
import { Intersection } from "@splidejs/splide-extension-intersection";
/**
 * Initializes the Sliders component.
 */

const Sliders = () => {
	const productsSlider = document.querySelector(".products__wrapper-slider");
	const processSlider = document.querySelector(".js-process-items");

	if (processSlider) {
		const processSliderSplide = new Splide(".js-process-items", {
			type: "slide",
			arrows: false,
			pagination: false,
			gap: 32,
			autoplay: 'pause',
			interval: 5000,
			autoWidth: true,
			isNavigation: true,
			pauseOnHover: true,
			updateOnMove: true,
			rewind: true,
			intersection: {
				inView: {
					autoplay: true,
				},
				outView: {
					autoplay: false,
				},
			},
            breakpoints: {
                1024: {
                    pauseOnHover: false,
                    perPage: 2,
                    autoWidth: false,
                    updateOnMove: false,
                    autoplay: true,
                },
                650: {
                    perPage: 1,
                    pagination: true,
                    pauseOnHover: false,
                    autoWidth: false,
                    updateOnMove: false,
                }      
            }
		});

		processSliderSplide.mount({ Intersection });

        processSliderSplide.on('intersection:in', () => {
            processSliderSplide.root.classList.add('is-visible');
        });

        processSliderSplide.on('intersection:out', () => {
            processSliderSplide.root.classList.remove('is-visible');
        });

		processSliderSplide.on("click", () => {
			processSliderSplide.Components.Autoplay.play(true);
		});
	}

	if (productsSlider) {
		const productsSliderNext = document.querySelector(
			".products__wrapper-nav-arrows-next"
		);
		const productsSliderPrev = document.querySelector(
			".products__wrapper-nav-arrows-prev"
		);
		const productsSliderPagination = document.querySelectorAll(
			".products__wrapper-nav-pagination-item"
		);

		var productsSliderSplide = new Splide(".products__wrapper-slider", {
			type: "slide",
			perPage: 1,
			arrows: false,
			pagination: false,
			gap: 30,
			pagination: true,
		});

		productsSliderSplide.mount();

		function updateArrows(index) {
			const lastIndex = productsSliderSplide.Components.Slides.getLength() - 1;

			if (index <= 0) {
				productsSliderPrev.classList.add("inactive");
			} else {
				productsSliderPrev.classList.remove("inactive");
			}

			if (index >= lastIndex) {
				productsSliderNext.classList.add("inactive");
			} else {
				productsSliderNext.classList.remove("inactive");
			}
		}

		updateArrows(productsSliderSplide.index);

		productsSliderSplide.on("move", (newIndex) => {
			updateArrows(newIndex);
		});

		if (productsSliderPagination.length > 0) {
			productsSliderPagination.forEach((item) => {
				item.addEventListener("click", () => {
					const index = parseInt(item.dataset.index, 10);
					productsSliderSplide.go(index);
				});
			});

			productsSliderSplide.on("move", (newIndex) => {
				productsSliderPagination.forEach((item, i) => {
					item.classList.toggle("active", i === newIndex);
				});
			});

			productsSliderPagination.forEach((item, i) => {
				item.classList.toggle("active", i === productsSliderSplide.index);
			});
		}

		if (productsSliderNext) {
			productsSliderNext.addEventListener("click", (e) => {
				productsSliderSplide.go("+1");
			});
		}

		if (productsSliderPrev) {
			productsSliderPrev.addEventListener("click", (e) => {
				productsSliderSplide.go("-1");
			});
		}
	}
};

export default Sliders;
